<template>
  <div :class="$style['expert-page']">
    <p :class="$style['expert-title']">特聘专家</p>
    <p :class="$style['expert-summer']">以下按专家名字首字母排序，不分先后</p>
    <div  v-for="(item,index) in expertList" :key="index">
      <div :class="$style['expert-content']" @click="showDesc(index)">
        <img :class="$style['content-img']" :src="item.avatar" />
        <div :class="$style['content']">
          <p :class="$style['name']">{{item.name}}</p>
          <p :class="$style['desc']">{{item.title}}</p>
        </div>
      </div>
      <div :class="$style['expert-text-wrapper']" v-if="item.show">
        <img src="@/assets/img/number/fengexian.png" :class="$style['split-line']"/>
        <div :class="$style['expert-text']">{{item.introHtml}}</div>
        <div :class="$style['split-expert']"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { expertList } from './data'

export default {
  name: '',
  components: {
  },
  props: {
  // visible: VueTypes.bool.def(false)
  },
  data () {
    return {
      expertList
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    showDesc (index) {
      this.expertList.map((it, ind) => {
        if (ind === index) {
          it.show = true
        } else {
          it.show = false
        }
      })
    }
  }
}
</script>
<style lang='scss' module>
.expert-page {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 50px 0;
  background: #F9F9F9;
  text-align: center;

  & .expert-title {
    font-size: 20px;
    font-weight: 500;
    color: #404040;
    line-height: 28px;
  }
  & .expert-summer {
    margin-top: 10px;
    font-size: 16px;
    font-weight: 400;
    color: #888888;
  }

  & .expert-content {
    display: flex;
    justify-content: flex-start;
    margin-top: 40px;
    padding: 0 30px;
    & .content-img {
      width: 80px; height: 100px;
    }
    & .content {
      width: 219px;
      margin-left: 16px;
      text-align: left;
      & .name {
        // margin-top: 5px;
        font-size: 17px;
        font-weight: 500;
        color: #404040;
      }
      & .desc {
        margin-top: 10px;
        font-size: 13px;
        font-weight: 300;
        color: #888888;
        line-height: 18px;
      }

    }
  }

  .expert-list {
    margin-top: 30px;
  }

  & .split-line {
    margin: 20px 0 0;
    padding: 0 20px;
  }

  & .expert-text {
    position: relative;
    padding: 20px 40px 19px;
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    color: #404040;
    line-height: 28px;
    background:
      url(../../assets/img/number/fuhao-zuo.png) no-repeat top 9px left 20px / 12px 11px,
      url(../../assets/img/number/fuhao-you.png) no-repeat bottom 10px right 20px / 12px 11px;
  }
  & .split-expert {
    box-sizing: border-box;
    height: 1px;
    margin: 0 20px;
    background: #B8D1F8;
  }
}

.expert-text-wrapper {
  position: relative;
}
</style>
